import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput, SingleSelect } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, EditButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getUserInfoCompanyId, getval2Token } from '../../../../Login/Auth';
import { api_addGame, api_getGameDetail, api_checkGameNo, api_getScorerList, api_getLastGameBoard, api_getGameCurrentAll } from '../../../../../api/MyStat/apiGame';
import { KEY_AWAY_TEAM_STRING, KEY_GAME_ACTIVATION_STRING, KEY_GAME_NO_STRING, KEY_GAME_DATE_STRING, KEY_GAME_TIME_STRING, KEY_GAME_TYPE_STRING, KEY_HOME_TEAM_STRING, KEY_LEAGUE_ASSOCIATION_STRING, KEY_GAME_FIELD_STRING, KEY_GAME_STATUS_STRING, KEY_SCORER_STRING, KEY_SCORING_STATUS_STRING, ReqGameDetail, RespGame, game_time_arr, game_status_arr, scoring_status_arr, game_status_only_arr, scoring_status_only_arr, GAME_STATUS_SCHEDULED, SCORING_STATUS_NOT_RECORDED } from '../../../../../item/MyStat/ItemGame';
import { UploadPhoto } from '../UploadPhoto';
import { get_activation_string, activation_Items, activation_only_disable, ACTIVATION_ENABLE, ACTIVATION_DISABLE } from '../../../../../item/MyStat/ItemMyStatBase';
import 'rc-datepicker/lib/style.css';
import { api_getLeagueGameTypeList, api_getLeagueListEnable } from '../../../../../api/MyStat/apiLeague';
import { api_getParkListEnable } from '../../../../../api/MyStat/apiPark';
import { uuid } from '../../../../../item/ItemTools';
import { api_getLeagueTeamList } from '../../../../../api/MyStat/apiTeam';
import { DatePickerInput } from 'rc-datepicker';
import { GameScoreboard } from './GameScoreboard';
import { GameEditInfo } from './GameEditInfo';
import { RespBoard } from '../../../../../item/MyStat/ItemBoard';


export function GameEdit({ id, setIsLoading, isEdit, isAdd = false }) {
  const [tokenId, setTokenId] = useState("")
  const [league_association_List, set_league_association_List] = useState([])
  const [league_association_arr, set_league_association_arr] = useState([])
  const [game_type_arr, set_game_type_arr] = useState([])
  const [team_arr, set_team_arr] = useState([])
  const [field_arr, set_field_arr] = useState([])
  const [scorer_arr, set_scorer_arr] = useState([])

  // const [_id, set_id] = useState("")
  const [game_id, set_game_id] = useState("")
  const [game_No, set_game_No] = useState("")
  const [game_date, set_game_date] = useState(moment().format('YYYY-MM-DD'))
  const [game_time, set_game_time] = useState(0)
  const [league_association, set_league_association] = useState("")
  const [game_type, set_game_type] = useState("")
  const [game_activation, set_game_activation] = useState(ACTIVATION_DISABLE)
  const [game_last_change, set_game_last_change] = useState("")
  const [game_field, set_game_field] = useState("")

  const [home_team, set_home_team] = useState("")
  const [home_score, set_home_score] = useState(-1)
  const [away_team, set_away_team] = useState("")
  const [away_score, set_away_score] = useState(-1)

  const [game_umpire, set_game_umpire] = useState("")
  const [scorer, set_scorer] = useState("")
  const [game_status, set_game_status] = useState(isAdd ? GAME_STATUS_SCHEDULED : "")
  const [scoring_status, set_scoring_status] = useState(isAdd ? SCORING_STATUS_NOT_RECORDED : "")
  const [isLock, set_isLock] = useState(false)

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")

  const [birthError, setBirthError] = useState(false)

  const [is_get_league_association, set_is_get_league_association] = useState(false)

  const [gameCurrentAll, setGameCurrentAll] = useState(undefined)

  var loadingFinish = [false, false]

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("GameEdit", id)
      console.log(obj)
      set_game_id(obj.game_id)
      setTokenId(id)
    }
    if (isAdd) {
      set_game_id(uuid(32, 64))
    }
  }, [id])

  useEffect(() => {
    get_league_association()
    get_park_list()
    get_scorer_list()
  }, [])

  useEffect(() => {
    if (!is_get_league_association) {
      return
    }
    if (!isAdd && game_id !== undefined && game_id !== "") {
      // setIsLoading(true)
      var mReqGameDetail = new ReqGameDetail({
        game_id
      })
      getDetail(mReqGameDetail)
      getGameCurrentAll(mReqGameDetail)
    }
  }, [game_id, is_get_league_association])

  useEffect(() => {
    get_team_list()
    if (league_association !== "") {
      var filterEmpty = league_association_List.filter((item) => {
        return item.league_id === league_association;
      });
      console.log(filterEmpty[0].game_types)
      set_game_type_arr(filterEmpty[0].game_types)
    } else {
      set_game_type_arr([])
      set_game_type('')
    }
  }, [league_association])


  // function onChange_league_association(val) {
  //   var filterEmpty = league_association_List.filter((item) => {
  //     return item.league_id === val;
  //   });
  //   console.log(filterEmpty[0].game_types)
  //   set_game_type_arr(filterEmpty[0].game_types)
  //   set_league_association(val)
  // }


  function get_league_association() {
    // if (setIsLoading !== undefined)
    //   setIsLoading(true)
    api_getLeagueGameTypeList({
      success: (obj) => {
        // console.log(obj)
        var arr = []
        obj.items.forEach(item => {
          arr.push({ val: item.league_id, name: item.league_name })
        })
        // console.log(arr)
        set_league_association_arr(arr)
        set_league_association_List(obj.items)
        set_is_get_league_association(true)
        // if (setIsLoading !== undefined)
        //   setIsLoading(false)
      },
      failure: (err) => {
        // if (setIsLoading !== undefined)
        //   setIsLoading(false)
      }
    })
  }

  function get_team_list() {
    // if (setIsLoading !== undefined)
    //   setIsLoading(true)
    api_getLeagueTeamList({
      league_id: league_association,
      success: (obj) => {
        // console.log(obj)
        var arr = []
        obj.list.forEach(item => {
          arr.push({ val: item.team_id, name: item.team_name })
        })
        // console.log(arr)
        set_team_arr(arr)
        // if (setIsLoading !== undefined)
        //   setIsLoading(false)
      },
      failure: (err) => {
        // if (setIsLoading !== undefined)
        //   setIsLoading(false)
      }
    })
  }

  function get_park_list() {
    api_getParkListEnable({
      success: (obj) => {
        console.log(obj)
        var arr = []
        obj.list.forEach(item => {
          arr.push({ val: item.park_id, name: item.park_name })
        })
        set_field_arr(arr)
      },
      failure: (err) => {

      }
    })
  }


  function get_scorer_list() {
    api_getScorerList({
      companyId: getUserInfoCompanyId(),
      success: (obj) => {
        console.log(obj)
        var arr = []
        obj.list.forEach(item => {
          arr.push({ val: item.accountId, name: item.nickName })
        })
        set_scorer_arr(arr)
      },
      failure: (err) => {

      }
    })
  }

  function getDetail(mReqGameDetail) {
    console.log(mReqGameDetail)
    setIsLoading(true)
    api_getGameDetail({
      mReqGameDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespGame = new RespGame({})
        mRespGame.fromJson(jsonData.detail)

        // set_id(mRespGame.id)
        set_game_No(mRespGame.game_No)
        set_league_association(mRespGame.league_association)
        set_game_type(mRespGame.game_type)
        set_game_field(mRespGame.game_field)
        set_game_date(moment(mRespGame.game_date).format('YYYY-MM-DD'))
        set_game_time(mRespGame.game_time)
        set_home_team(mRespGame.home_team)
        set_home_score(mRespGame.home_score)
        set_away_team(mRespGame.away_team)
        set_away_score(mRespGame.away_score)
        set_game_umpire(mRespGame.game_umpire)
        set_scorer(mRespGame.scorer)
        set_game_status(mRespGame.game_status)
        set_scoring_status(mRespGame.scoring_status)
        set_game_activation(mRespGame.game_activation)
        set_game_last_change(moment(mRespGame.game_last_change).format('YYYY-MM-DD'))
        set_isLock(mRespGame.isLock)
        loadingFinish[0] = true;
        checkLoadingFinish()

      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }
  function checkGameNo(val) {
    api_checkGameNo({
      game_no: val,
      success: (jsonData) => {
        console.log(jsonData)
        setCheckRepeat(true)
        if (jsonData.game_date === "") {
          setRepeat(false)
          setRepeatMessage("")
        } else {
          setRepeat(true)
          setRepeatMessage(moment(jsonData.game_date).format('YYYY/MM/DD'))
        }
      },
      failure: (err) => {
        console.log(err)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function getGameCurrentAll(mReqGameDetail) {
    api_getGameCurrentAll({
      mReqGameDetail,
      success: (jsonData) => {
        console.log(jsonData)
        // var mRespBoard = new RespBoard({})
        // mRespBoard.fromJson(jsonData.items)
        // setRespBoard(mRespBoard)
        // console.log(mRespBoard)
        setGameCurrentAll(jsonData.items)
        loadingFinish[1] = true;
        checkLoadingFinish()
      },
      failure: (err) => {

      }
    })
  }

  function checkLoadingFinish(){
    if(loadingFinish[0] && loadingFinish[1])
      setIsLoading(false)
  }

  const onChange = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setBirthError(true)
    } else {
      setBirthError(false)
      set_game_date(dateString)
    }
  }


  function toEdit() {
    window.location.assign("/Game_Edit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    // console.log(team_type)
    var inputError = []
    var dateError = []
    var repeatError = []
    if (game_No === "") {
      inputError.push(KEY_GAME_NO_STRING)
    }
    if (league_association === "") {
      inputError.push(KEY_LEAGUE_ASSOCIATION_STRING)
    }
    if (game_type === "") {
      inputError.push(KEY_GAME_TYPE_STRING)
    }
    if (game_field === "") {
      inputError.push(KEY_GAME_FIELD_STRING)
    }
    if (home_team === "") {
      inputError.push(KEY_HOME_TEAM_STRING)
    }
    if (away_team === "") {
      inputError.push(KEY_AWAY_TEAM_STRING)
    }
    if (home_team !== "" && away_team !== "" && home_team === away_team) {
      repeatError.push(KEY_HOME_TEAM_STRING + '與' + KEY_AWAY_TEAM_STRING + '不得相同')
    }

    console.log(inputError)

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    } else if (repeatError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: repeatError.join(','),
      })
      return
    } else if (dateError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: dateError.join(','),
      })
      return
    }
    setIsLoading(true)
    var mRespGame = new RespGame({
      game_id,
      game_No,
      league_association,
      game_type,
      game_field,
      game_date,
      game_time,
      home_team,
      // home_score,
      away_team,
      // away_score,
      game_umpire,
      scorer,
      game_status,
      game_activation,
      scoring_status,
      game_last_change
    })

    console.log(mRespGame)
    api_addGame({
      isAdd,
      mRespGame,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "賽事基本資料"
  var dangerTitle = isLock ? <>&nbsp;&nbsp;已鎖定</> : ""
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">
          {isEdit ?
            <SingleInput title={KEY_GAME_NO_STRING} val={game_No} action={set_game_No} action_blur={checkGameNo} placeholder={""} size={3} />
            : <SingleText title={KEY_GAME_NO_STRING} val={game_No} size={4} />
          }
          {isEdit ?
            <SingleSelect title={KEY_LEAGUE_ASSOCIATION_STRING}
              val={league_association}
              attr={league_association_arr}
              action={set_league_association}
              hasBlank={true}
              size={3}
            />
            : <SingleText title={KEY_LEAGUE_ASSOCIATION_STRING} val={away_score} size={3} />
          }
          {isEdit ?
            <SingleSelect title={KEY_GAME_TYPE_STRING}
              val={game_type}
              attr={game_type_arr}
              action={set_game_type}
              n={'game_type_name'}
              v={'game_type'}
              hasBlank={true}
              size={3}
            />
            : <SingleText title={KEY_GAME_TYPE_STRING} val={away_score} size={3} />
          }
          {
            isEdit ?
              <SingleSelect title={KEY_GAME_ACTIVATION_STRING}
                attr={isAdd ? activation_only_disable : activation_Items}
                val={game_activation ? ACTIVATION_ENABLE : ACTIVATION_DISABLE}
                action={set_game_activation}
                size={3}
              />
              :
              <SingleText title={KEY_GAME_ACTIVATION_STRING}
                val={get_activation_string(game_activation)}
                size={3} />
          }
        </div>
        {!isRepeat ? <></> :
          <div className="col-sm-12">
            <div className="col-sm-4">
              <p></p>
              <SingleText val={'與' + repeatMessage + '賽事，相同編號'} color={'danger'} size={12} />
            </div>
          </div>
        }

        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>

        <div className="col-sm-12">
          {isEdit ?
            <SingleSelect title={KEY_HOME_TEAM_STRING}
              val={home_team}
              attr={team_arr}
              action={set_home_team}
              hasBlank={true}
              size={2}
            />
            : <SingleText title={KEY_HOME_TEAM_STRING} val={home_team} size={2} />
          }
          {isEdit ?
            <SingleSelect title={KEY_AWAY_TEAM_STRING}
              val={away_team}
              attr={team_arr}
              action={set_away_team}
              hasBlank={true}
              size={2}
            />
            : <SingleText title={KEY_AWAY_TEAM_STRING} val={away_team} size={2} />
          }
          {isEdit ?
            <SingleSelect title={KEY_GAME_FIELD_STRING}
              val={game_field}
              attr={field_arr}
              action={set_game_field}
              hasBlank={true}
              size={2}
            />
            : <SingleText title={KEY_GAME_FIELD_STRING} val={game_field} size={2} />
          }
          {isEdit ?
            <div className="col-md-3">
              <p>{KEY_GAME_DATE_STRING}</p>
              <DatePickerInput
                displayFormat='YYYY/MM/DD'
                returnFormat='YYYY-MM-DD'
                onChange={onChange}
                value={game_date}
                className='my-react-component'
                showOnInputClick={true}
              />
            </div>
            : <SingleText title={KEY_GAME_DATE_STRING} val={game_date} size={4} />
          }
          {isEdit ?
            <SingleSelect title={KEY_GAME_TIME_STRING}
              val={game_time}
              attr={game_time_arr}
              action={set_game_time}
              hasBlank={true}
              size={3}
            />
            : <SingleText title={KEY_GAME_TIME_STRING} val={game_time} size={3} />
          }
        </div>
        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>
        <div className="col-sm-12">
          {isEdit ?
            <SingleSelect title={KEY_GAME_STATUS_STRING}
              val={game_status}
              attr={isAdd ? game_status_only_arr : game_status_arr}
              action={set_game_status}
              size={3}
            />
            : <SingleText title={KEY_GAME_STATUS_STRING} val={game_status} size={3} />
          }
          {isEdit ?
            <SingleSelect title={KEY_SCORER_STRING}
              val={scorer}
              attr={scorer_arr}
              action={set_scorer}
              hasBlank={true}
              size={3}
            />
            : <SingleText title={KEY_SCORER_STRING} val={scorer} size={3} />
          }
          {isEdit ?
            <SingleSelect title={KEY_SCORING_STATUS_STRING}
              val={scoring_status}
              attr={isAdd ? scoring_status_only_arr : scoring_status_arr}
              action={set_scoring_status}
              size={3}
            />
            : <SingleText title={KEY_SCORING_STATUS_STRING} val={scoring_status} size={3} />
          }
        </div>
        <Space />
        <Space />
      </div>
    </>

  var footer =
    <div className="row">
      <div className="row">
        {
          isAdd || isEdit ?
            <div className="col-sm-3 col-sm-offset-9">
              <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
            </div>
            :
            <EditButton action={toEdit} isRight={true} />
        }
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} dangerTitle={dangerTitle} titleSize={6} content={content} footer={footer} hasDrawer={false} />
      {
        !isAdd && isEdit ?
          <>
            <GameScoreboard game_id={game_id} gameCurrentAll={gameCurrentAll} />
            <GameEditInfo />
          </>
          : <></>
      }
      <SystemPromptInput />
    </>
  )
}